export default "__VITE_ASSET__a2c76108__"